import { TextoSelecionado } from "../presentation/components/Observer"

export const translateSobre = {
    pt: {
        sobre: {
            titulo: "SOBRE MIM",
            
            // Trocamos as aspas por <> </> para o React entender o componente
            paragrafo1: (
                <>
                    Olá! Sou o Tiago Lucas. Minha jornada na tecnologia <TextoSelecionado delay={1515}>começou com uma forte base técnica</TextoSelecionado>, evoluindo desde a infraestrutura até o desenvolvimento de software. Hoje, atuo profissionalmente na Codie e continuo aprimorando minhas habilidades na área de Análise e Desenvolvimento de Sistemas.
                </>
            ),
            
            paragrafo2: (
                <>
                    Sou um desenvolvedor Full-Stack, mas <TextoSelecionado delay={11000}>meu grande foco e especialidade estão no Back-end</TextoSelecionado> — estruturando bancos de dados, construindo APIs escaláveis e desenvolvendo soluções robustas com C# e Python. Além do código, também aplico minha criatividade trabalhando com design gráfico.
                </>
            ),
            
            paragrafo3: (
                <>
                    Este espaço é um portfólio das minhas soluções e projetos. E quando não estou programando ou criando artes, você me encontra imerso no universo de Harry Potter, maratonando animes ou, <TextoSelecionado delay={22000}>claro, acompanhando fielmente One Piece.</TextoSelecionado>
                </>
            )
        }
    },

    en: {
        sobre: {
            titulo: "ABOUT ME",
            
            paragrafo1: (
                <>
                    Hello! I'm Tiago Lucas. My journey in tech <TextoSelecionado delay={1515}>started with a strong technical foundation</TextoSelecionado>, evolving from infrastructure to software development. Today, I work professionally at Codie and continue to hone my skills in Systems Analysis and Development.
                </>
            ),
            
            paragrafo2: (
                <>
                    I'm a Full-Stack developer, but <TextoSelecionado delay={11000}>my main focus and expertise are in the Back-end</TextoSelecionado> — structuring databases, building scalable APIs, and developing robust solutions with C# and Python. Beyond coding, I also apply my creativity working with graphic design.
                </>
            ),
            
            paragrafo3: (
                <>
                    This space serves as a portfolio for my solutions and projects. And when I'm not programming or creating art, you can find me immersed in the Harry Potter universe, binge-watching anime, or, <TextoSelecionado delay={22000}>of course, faithfully following One Piece.</TextoSelecionado>
                </>
            )
        }
    }
};